export default __webpack_public_path__ + "static/media/fontRoboto900_latin.2e8becfc.woff2";